// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"1cdca33f","994":"afddede7"}[chunkId] + ".chunk.css";
};